<!-- <div class="layout-wrapper" [ngClass]="{'p-input-filled': service.inputStyle === 'filled', 'p-ripple-disabled': !service.ripple,
        'layout-menu-static': service.isStaticMenu,
        'layout-menu-overlay': service.isOverlayMenu,
        'layout-menu-horizontal': service.isHorizontalMenu,
        'layout-menu-slim': service.isSlimMenu,
        'layout-menu-active': service.menuActive,
        'layout-menu-mobile-active': service.mobileMenuActive,
        'layout-topbar-mobile-active': service.mobileTopbarActive,
        'layout-rightmenu-active': service.rightMenuActive || !!this.rightPanelService.customViewSync,
        'layout-rtl': service.isRTL}"
    [class]="'layout-menu-' + service.menuTheme + ' layout-topbar-' + service.topbarTheme"> -->
<div layout-fill class="layout-wrapper" [ngClass]="
{
    'layout-compact':layoutCompact,
        'layout-menu-static': service.isStaticMenu,
        'layout-menu-active': service.menuActive
}" (click)="onLayoutClick()">

    <div #layoutContainer class="layout-container custom" [ngClass]="{
        'p-input-filled': this.service.inputStyle === 'filled',
        'menu-layout-overlay': this.service.isOverlayMenu,
        'menu-layout-horizontal': this.service.isHorizontalMenu,
        'menu-layout-overlay-active': overlayMenuActive,
        'menu-layout-slim': this.service.isSlimMenu,
        'menu-layout-static-inactive': this.service.staticMenuDesktopInactive,
        'menu-layout-static-active': staticMenuMobileActive}">

        <app-topbar></app-topbar>

        <!-- <app-rightmenu></app-rightmenu> -->


        <!-- <div class="menu-wrapper" (click)="onMenuClick($event)">
            <div class="layout-menu-container layout-menu">
                <app-inline-menu *ngIf="app.inlineMenuPosition=='top' || app.inlineMenuPosition=='both'" key="top"></app-inline-menu>
                <app-menu></app-menu>
                <app-inline-menu key="bottom"></app-inline-menu>
                <app-inline-menu *ngIf="app.inlineMenuPosition=='bottom' || app.inlineMenuPosition=='both'" key="bottom"></app-inline-menu>
            </div>
        </div> -->

        <div class="layout-menu" [ngClass]="{'layout-menu-dark':darkMenu}" (click)="onMenuClick($event)">
            <p-scrollPanel #scrollPanel [style]="{height: '100%'}">
                <app-menu [reset]="resetMenu"></app-menu>
            </p-scrollPanel>
        </div>

        <div class="layout-main" layout-fill>

            <!-- <div layout-fill class="layout-main"> -->
            <!-- <app-breadcrumb></app-breadcrumb> -->

            <ng-container *ngIf="requiredConfigurations$ | async; let requiredConfigurations">

                <router-outlet *ngIf="requiredConfigurations?.length == 0"></router-outlet>

                <div class="scroll-container" *ngIf="requiredConfigurations?.length > 0" class="tw-flex tw-basis-full"
                    (click)="this.onRightPanelButtonClick($event)">
                    <div class="scroll-content tw-flex tw-basis-full tw-w-full tw-items-stretch">
                        <section class="page-content tw-flex tw-basis-full tw-justify-center tw-items-center tw-flex-col">
                            <section class="card tw-flex tw-basis-[30%] tw-flex-col tw-space-y-[30px] tw-cursor-pointer">
                                <h2 class="tw-self-center">
                                    Missing Configuration
                                </h2>
                                <span class="tw-self-center tw-flex tw-basis-full tw-flex-col">
                                    <em *ngFor="let missing of requiredConfigurations">{{missing}}</em>
                                </span>

                                <span class="tw-flex tw-basis-auto tw-flex-col">
                                    <em>Please, click here to configure the missing settings</em>
                                </span>
                            </section>
                        </section>
                    </div>
                </div>

            </ng-container>
            <!--<app-footer></app-footer>-->
        </div>

        <app-rightpanel></app-rightpanel>

        <div class="layout-mask"></div>
    </div>

</div>

<p-toast position="top-right" [styleClass]="'custom-toast'"></p-toast>

<div class="loading-indicator" *ngIf="progressMessage">
    <div class="tw-absolute tw--left-[50%]">
        <p-progressSpinner strokeWidth="5" [style]="{width: '65px', height: '65px'}"></p-progressSpinner>
        <div class="loading-title">{{progressMessage?.detail}}</div>
    </div>
</div>

<ng-container *ngIf="this.commandLazyDataService.executingCommandParse?.customView"
    [appLazy]="this.commandLazyDataService.executingCommandParse.customView"
    [appLazyData]="this.commandLazyDataService.executingCommandParse.customViewMetadata">
</ng-container>

{{this.commandLazyDataService.executingCommandParse?.customView | json}}
